import { parseContentPack } from "@unfaithful/shared";
import corePackJson from "./packs/core.json" with { type: "json" };
import moreMissions from "./packs/more-missions.json" with { type: "json" };
/**
 * What the TV and phones bundle: missions, prompts and Steward lines.
 * Challenges and secret tasks are left out on purpose — they carry answers, so
 * the server sends each one only when it is played.
 */
export const clientPack = parseContentPack({
    ...corePackJson,
    missions: [...corePackJson.missions, ...moreMissions],
});
/** Fill {placeholders} in a Steward line. Unknown placeholders are left as-is. */
export function fillLine(text, values) {
    return text.replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match);
}
//# sourceMappingURL=client.js.map